import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

export const editAdmissionSimulationSchema = yupResolver(
  yup.object({
    position: yup.string().required('Cargo é obrigatório'),
    startDate: yup.string().required('Data de admissão é obrigatória'),
    salary: yup.string().required('Salário é obrigatório')
  })
)
